import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonGroupOption } from '..';

let $id = 0;

@Component({
  selector: 'wfm-button-group',
  templateUrl: './button-group.component.html',
  styleUrls: ['./button-group.component.scss']
})
export class ButtonGroupComponent {
  @Input() set id(val: string) {
    this.sid = val;
  }
  get id(): string {
    return this.sid || `${this.$id}`;
  }

  @Input() options: Array<any | ButtonGroupOption> = undefined;

  @Input() selected: Array<any | ButtonGroupOption> = [];
  @Output() selectedChange = new EventEmitter<Array<any | ButtonGroupOption>>();

  @Input() multiple = false;

  isOpen = false;
  optionsOpen: ButtonGroupOption;

  mouseDown = false;

  private sid = '';
  private $id = 0;

  constructor() {
    this.$id = ++$id;
  }

  change(option: any) {
    this.selected = this.selected || [];
    const index = this.selected.indexOf(option);
    if (index >= 0) {
      this.selected.splice(index, 1);
    } else {
      this.selected = (this.multiple && this.selected) || [];
      this.selected.push(option);
    }

    this.selectedChange.emit(this.selected);
  }

  openSubOptions(option: ButtonGroupOption) {
    this.isOpen = this.optionsOpen === option ? !this.isOpen : true;
    this.optionsOpen = option;
    this.mouseDown = false;
  }

  reset(option: ButtonGroupOption) {
    option.selected = [];
    const index = this.selected.indexOf(option);
    if (index >= 0) {
      this.selected.splice(index, 1);
    }

    this.selectedChange.emit(this.selected);
    this.isOpen = false;
  }

  apply(option: ButtonGroupOption) {
    const index = this.selected.indexOf(option);
    if (index < 0) {
      this.selected = (this.multiple && this.selected) || [];
      this.selected.push(option);
    }

    this.selectedChange.emit(this.selected);
    this.isOpen = false;
  }

  closeOnMousedown = () => {
    return !this.mouseDown;
  };
}
